import { View, Text, Platform, type TextStyle } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import { EMBER } from "../../../onboarding/theme";
import StatusBadge from "../StatusBadge";
import { SCREEN_TITLE_GRADIENT_BACKGROUND_STYLE } from "../ScreenTitle";
import { colors } from "@louise/theme/tokens";

export default function DonorRegistryHeader() {
  const t = useTranslations();
  return (
    <View style={{ gap: 8, marginBottom: 28 }}>
      <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
        <Text
          className="font-dm-sans"
          style={
            {
              fontSize: 38,
              fontWeight: "700",
              color: colors.deepBrown,
              lineHeight: 42,
              letterSpacing: -0.5,
              ...(Platform.OS === "web" && {
                ...SCREEN_TITLE_GRADIENT_BACKGROUND_STYLE,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }),
            } as TextStyle
          }
        >
          {t("access.donor_registry.title")}
        </Text>
        <StatusBadge type="beta" />
      </View>
      <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 15,
            color: EMBER.colors.textLight,
            flex: 1,
          }}
        >
          {t("access.donor_registry.subtitle")}
        </Text>
      </View>
    </View>
  );
}
